/* istanbul ignore file */
import {
  createContext,
  useCallback,
  useContext,
  useRef,
  useState,
} from 'react';

interface SidebarOverlayContextType {
  isOverlayVisible: boolean;
  showOverlay: (source: string) => void;
  hideOverlay: (source: string) => void;
}

const SidebarOverlayContext = createContext<SidebarOverlayContextType>({
  isOverlayVisible: false,
  showOverlay: () => {},
  hideOverlay: () => {},
});

export const SidebarOverlayProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const overlaySources = useRef<Set<string>>(new Set());

  const showOverlay = useCallback((source: string) => {
    overlaySources.current.add(source);
    setIsOverlayVisible(true);
  }, []);

  const hideOverlay = useCallback((source: string) => {
    overlaySources.current.delete(source);
    if (overlaySources.current.size === 0) {
      setIsOverlayVisible(false);
    }
  }, []);

  return (
    <SidebarOverlayContext.Provider
      value={{ isOverlayVisible, showOverlay, hideOverlay }}
    >
      {children}
    </SidebarOverlayContext.Provider>
  );
};

export const useSidebarOverlayContext = () => useContext(SidebarOverlayContext);
